$(function () {

  
  if (location.pathname.match(/\/pages\/wishlist/)) {

    
    window.onpageshow = function (event) {
      if (event.persisted) {
        screenUnlock();
      }
    };

    const customerId = $('#wishlist-customerId').val(); 
    
    if (customerId) {
      
      getMyWishlist(customerId); 
    }
  }
  
  $('#wishlist-scope').on('click', '.delete-item', function () { 
    const favoriteId = $(this).data("favoriteid"); 
    const customerId = $('#wishlist-customerId').val(); 
    

    
    screenLock();

    
    deleteItemLoading(this);

    postDelete(customerId, favoriteId); 

    return true;
  });

  
  $('#wishlist-scope').on('click', '.add-cart-wishlist', function () {
    screenLock();
    const favoriteId = $(this).data("favoriteid"); 
    
    $(`#wishlist-cart-form-${favoriteId}`).submit(); 
  });

  
  $('#wishlist-scope').on('change', '#SortBy', function () {
    const selected = $(this).val();
    switch (selected) {
      case 'created-descending':
        $('#wishlist-itmes').html(
          $('#wishlist-itmes > li').sort(function (a, b) {
            var num1 = $(a).find('.wishItemNo').val();
            var num2 = $(b).find('.wishItemNo').val();
            return num1 - num2;
          })
        );
        break;
      case 'created-ascending':
        $('#wishlist-itmes').html(
          $('#wishlist-itmes > li').sort(function (a, b) {
            var num1 = $(a).find('.wishItemNo').val();
            var num2 = $(b).find('.wishItemNo').val();
            return num2 - num1;
          })
        );
        break;
      case 'price-ascending':
        $('#wishlist-itmes').html(
          $('#wishlist-itmes > li').sort(function (a, b) {
            var num1 = $(a).find('.sortPrice').val();
            var num2 = $(b).find('.sortPrice').val();
            return num1 - num2;
          })
        );
        break;
      case 'price-descending':
        $('#wishlist-itmes').html(
          $('#wishlist-itmes > li').sort(function (a, b) {
            var num1 = $(a).find('.sortPrice').val();
            var num2 = $(b).find('.sortPrice').val();
            return num2 - num1;
          })
        );
        break;
    }
  });
  
  
  $('.product__info-wrapper').on("change", function (event) {
    var variantId = getParam("variant");
    if (variantId != null && variantId != $('#variantsId').val()) {
      $('#variantsId').val(variantId);
      var wishLists = $('#wishLists').val();
      if (wishLists != null) {
        var variants = wishLists.split(',');
        if (variants.includes(String(variantId))) {
          $('#action').val("delete");
          $('.illi-wishlist-add-item').attr('style', 'display:none');
          $('.illi-wishlist-delete-item').attr('style', 'display:');
        }
        else {
          $('#action').val("add");
          $('.illi-wishlist-add-item').attr('style', 'display:');
          $('.illi-wishlist-delete-item').attr('style', 'display:none');
        }
      }
    }
  });

  
  $('.product__info-wrapper').on('click', '#wishlistButton', function () { 
    var customerId = $('#customerId').val();
    var productsId = $('#productsId').val();
    var variantId = $('#variantsId').val();
    var action = $('#action').val();
    var wishLists = $('#wishLists').val();
    screenLock();
    $(this).parents(".favorite-icon").addClass("hide");
    $(this).parents(".favorite-icon").next(".wishlist-loader").removeClass("hide");
    console.log("hoge");
    wishListUpdate($(this), customerId, productsId, variantId, action, wishLists);
  });

  
  var collection = $(".grid__item"); 
  var itemSection = $(".shopify-section"); 
  if (collection.length) {

    
    if ($(".illi-favorite").length) {
      itemSection.on('click', ".favorite-icon", function () {
        var illiFavorite = $(this).parents(".illi-favorite");
        var illiWishlistArea = illiFavorite.next(".illi-wishlist-area");
        
        if (illiWishlistArea.find(".variants-favorite-box").length == 1) {
          
          screenLock(); 
          illiFavorite.find(".favorite-icon").addClass("hide");
          illiFavorite.find(".wishlist-loader").removeClass("hide");
          var customerId = illiWishlistArea.find('.customerId').val();
          var productsId = illiWishlistArea.find('.productsId').val();
          var variantId = illiWishlistArea.find('.variantsId').val();
          var action = illiWishlistArea.find('.action').val();
          wishListUpdateCollection(illiFavorite, customerId, productsId, variantId, action, false);
        } else { 
          
          if (window.outerWidth < 767) {
            $("body").attr('style', 'overflow: hidden');
            $("body").addClass('wishlist-show');
          }
          illiFavorite.nextAll(".modal-overlay:first").fadeIn(); 
          illiFavorite.next(".illi-wishlist-area").fadeIn(); 
        }
      });
    }

    
    itemSection.on('click', '.favorite-sku-icon', function () {
      
      screenLock(); 
      $(this).addClass("hide");
      $(this).next(".wishlist-loader").removeClass("hide");
      var customerId = $(this).find('.customerId').val();
      var productsId = $(this).find('.productsId').val();
      var variantId = $(this).find('.variantsId').val();
      var action = $(this).find('.action').val();
      wishListUpdateCollection($(this), customerId, productsId, variantId, action, true);
    });

    
    itemSection.on('click', '.modal-close', function () {
      
      if (window.outerWidth < 767) {
        $("body").attr('style', 'overflow:');
        $("body").removeClass('wishlist-show');
      }
      $(".modal-overlay").fadeOut();
      $(".illi-wishlist-area").fadeOut();
    });
    itemSection.on('click', '.modal-overlay', function () {
      
      if (window.outerWidth < 767) {
        $("body").attr('style', 'overflow:');
        $("body").removeClass('wishlist-show');
      }
      $(".modal-overlay").fadeOut();
      $(".illi-wishlist-area").fadeOut();
    });
    itemSection.on('click', '.illi-wishlist-area-close', function () {
      
      if (window.outerWidth < 767) {
        $("body").attr('style', 'overflow:');
        $("body").removeClass('wishlist-show');
      }
      $(".modal-overlay").fadeOut();
      $(".illi-wishlist-area").fadeOut();
    });
  }

});

function getMyWishlist(customerId) {
  $.ajax({
    
    url: '/apps/wishlist-apps/index',
    type: 'POST',
    dataType: 'json',
    data: {
      customerId: customerId
    },
    timeout: 30000,
  }).then(
    function (res) { 
      if (res.status == 'success') {
        createWishlist(res.result); 
      } else {
        openErrorMessageDialog(res.result); 
      }
    },
    function () {
      openErrorMessageDialog("no connection."); 
      
      return null;
    }
  );
}


function createWishlist(wishlist) {
  let content = "";
  let count = 1;

  
  if (!wishlist) {
    $('#wishlist-itmes').html('<li>お気に入り商品はありません。</li>');
    return
  }

  
  for (const elem of wishlist) {
    const favoriteid = elem.productsId + elem.variantsId; 
    let productImage = null; 
    let addCartContent = null; 

    
    if (elem.image) {
      productImage = `<div class="item-image"><img src="${elem.image}" ></div>`;
    } else {
      productImage = '<div class="item-image no-image"></div>';
    }

    
    if (elem.addCart) {
      addCartContent = `<span class="add-cart-wishlist" data-favoriteid="${favoriteid}">`;
    } else {
      addCartContent = '<span class="cant-add-wishlist">';
    }
    
    content = content +
        `<li class="illi-wishlist-grid__item grid__item--collection-template small--one-half medium-up--one-quarter">
        <div class="illi-wishlist-grid-view-item illi-wishlist-product-card">
              <a class="illi-wishlist-grid-view-item__link illi-wishlist-grid-view-item__image-container illi-wishlist-full-width-link" href="/products/${elem.handle}">
                <span class="visually-hidden">${elem.title}</span>
              </a>
          <div class="illi-wishlist-product-card__image-with-placeholder-wrapper">
            <div class="grid-view-item__image-wrapper illi-wishlist-product-card__image-wrapper js">
                  ${productImage}
              </div>
              <div class="h4 grid-view-item__title illi-wishlist-product-card__title" aria-hidden="true">${elem.title}</div>
            <dl class="illi-wishlist-price price--listing">
                <div class="price__regular">
                    <dd>
                          <span class="price-item price-item--regular">¥${String(elem.price).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')}</span>
                    </dd>
                  </div>
            </dl>
        </div>
        <div id="delete-form-${favoriteid}">
              <span class="delete-item" data-favoriteid="${favoriteid}"></span>
            <input type="hidden" id="productsId-${favoriteid}" value="${elem.productsId}" />
            <input type="hidden" id="variantsId-${favoriteid}" value="${elem.variantsId}" />
        </div>
        <form id="wishlist-cart-form-${favoriteid}" method="post" action="/cart/add" >
            <input type="hidden" name="id" value="${elem.variantsId}" />
            <input type="hidden" name="quantity" value ="1" /> 
        </form>
        ${addCartContent}
            <span class="add-cart-logo">
                <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-cart" viewBox="0 0 37 40"><path d="M36.5 34.8L33.3 8h-5.9C26.7 3.9 23 .8 18.5.8S10.3 3.9 9.6 8H3.7L.5 34.8c-.2 1.5.4 2.4.9 3 .5.5 1.4 1.2 3.1 1.2h28c1.3 0 2.4-.4 3.1-1.3.7-.7 1-1.8.9-2.9zm-18-30c2.2 0 4.1 1.4 4.7 3.2h-9.5c.7-1.9 2.6-3.2 4.8-3.2zM4.5 35l2.8-23h2.2v3c0 1.1.9 2 2 2s2-.9 2-2v-3h10v3c0 1.1.9 2 2 2s2-.9 2-2v-3h2.2l2.8 23h-28z"></path></svg>
            </span>
        </span>
		<input class="wishItemNo" type="hidden" value="${count}">
		<input class="sortPrice" type="hidden" value="${elem.price.replace('～','')}">
		</li>`;
        count += 1;
  }
  $('#wishlist-itmes').html(content); 
  $('#wishlist-item-count').html(wishlist.length); 
  return
}


function postDelete(customerId, favoriteId) {
  $.when(
    $.ajax({
      url: '/apps/wishlist-apps/update', 
      type: 'POST',
      dataType: 'json',
      data: {
        customerId: customerId,
        productsId: $(`#productsId-${favoriteId}`).val(), 
        variantsId: $(`#variantsId-${favoriteId}`).val(), 
        wishlistAction: "delete",
      },
      timeout: 30000,

    }).then(
      function (res) { 
        if (res.status == 'success') {
          
          
          const wishItemCount = Number($('#wishlist-item-count').text());
          
          if (wishItemCount > 1) {
            $(`#delete-form-${favoriteId}`).parent().parent().remove();
            $('#wishlist-item-count').html(wishItemCount - 1);
          }
          else {
            $(`#wishlist-itmes`).html('<li>お気に入り商品はありません。</li>');
            $('#wishlist-item-count').html(0);
          }
        } else {
          openErrorMessageDialog(res.result); 
        }
      },
      function () {
        openErrorMessageDialog("no connection."); 
      }
    )
  ).done(function () {
    
    screenUnlock();

    
    deleteItemUnloading(this);
  }
  );
}




function wishListUpdate(thisElement, customerId, productsId, variantId, action, wishLists) {
  var favoriteIcon = $(thisElement).parents(".favorite-icon");
  $.when(
    $.ajax({
      url: '/apps/wishlist-apps/update', 
      type: 'POST',
      dataType: 'json',
      data: {
        customerId: customerId,
        productsId: productsId,
        variantsId: variantId,
        wishlistAction: action,
      },
      timeout: 30000,
    }).then(
      function (res) { 
        if (res.status == 'success') {
          
          
          if (action == "delete") {
            $('#action').val("add");
            favoriteIcon.find('.illi-wishlist-add-item').attr('style', 'display:');
            favoriteIcon.find('.illi-wishlist-delete-item').attr('style', 'display:none');
            var variants = wishLists.split(',').filter(v => v != variantId);
            $('#wishLists').val(variants.join(','));
          }
          else {
            $('#action').val("delete");
            favoriteIcon.find('.illi-wishlist-add-item').attr('style', 'display:none');
            favoriteIcon.find('.illi-wishlist-delete-item').attr('style', 'display:');
            var variants = wishLists.split(',');
            variants.push(variantId);
            $('#wishLists').val(variants.join(','));
          }
        } else {
          openErrorMessageDialog(res.result); 
        }
      },
      function () {
        openErrorMessageDialog("no connection."); 
      }
    )
  ).done(function () {
    favoriteIcon.next(".wishlist-loader").addClass("hide");
    favoriteIcon.removeClass("hide");
    screenUnlock();
  }
  );
}


function wishListUpdateCollection(thisElement, customerId, productsId, variantId, action, isVariant) {
  
  if (isVariant) {
    var variantsFavoriteBox = $(thisElement).parents(".variants-favorite-box");
    var parentsFavoriteBox = $(thisElement).parents(".illi-wishlist-area").find(".variants-favorite-box");
  } else { 
    var variantsFavoriteBox = $(thisElement).next(".illi-wishlist-area").find(".variants-favorite-box");
    var parentsFavoriteBox = variantsFavoriteBox;
  }
  var illiFavorite = variantsFavoriteBox.parents(".illi-wishlist-area").prevAll(".illi-favorite:first");
  $.when(
    $.ajax({
      url: '/apps/wishlist-apps/update', 
      type: 'POST',
      dataType: 'json',
      data: {
        customerId: customerId,
        productsId: productsId,
        variantsId: variantId,
        wishlistAction: action,
      },
      timeout: 30000,
    }).then(
      function (res) { 
        if (res.status == 'success') {
          if (action == "delete") {
            variantsFavoriteBox.find('.action').val("add");
            variantsFavoriteBox.find('.illi-wishlist-add-item').attr('style', 'display:');
            variantsFavoriteBox.find('.illi-wishlist-add-item').attr("data-favorite", "on");
            variantsFavoriteBox.find('.illi-wishlist-delete-item').attr('style', 'display:none');
            variantsFavoriteBox.find('.illi-wishlist-delete-item').attr("data-favorite", "off");
          }
          else {
            variantsFavoriteBox.find('.action').val("delete");
            variantsFavoriteBox.find('.illi-wishlist-add-item').attr('style', 'display:none');
            variantsFavoriteBox.find('.illi-wishlist-add-item').attr("data-favorite", "off");
            variantsFavoriteBox.find('.illi-wishlist-delete-item').attr('style', 'display:');
            variantsFavoriteBox.find('.illi-wishlist-delete-item').attr("data-favorite", "on");
          }
          
          var isFavoreite = false;
          parentsFavoriteBox.each(function (index, favoriteIcon) {
            if ($(favoriteIcon).find('.illi-wishlist-delete-item').attr("data-favorite") == "on") {
              isFavoreite = true;
            }
          });
          if (isFavoreite) {
            illiFavorite.find(".collection-favorite-none").attr('style', 'display:none');
            illiFavorite.find(".collection-favorited").attr('style', 'display:');
          } else {
            illiFavorite.find(".collection-favorited").attr('style', 'display:none');
            illiFavorite.find(".collection-favorite-none").attr('style', 'display:');
          }
        } else {
          openErrorMessageDialog(res.result); 
        }
      },
      function () {
        openErrorMessageDialog("no connection."); 
      }
    )
  ).done(function () {
    
    variantsFavoriteBox.find(".wishlist-loader").addClass("hide");
    variantsFavoriteBox.find(".favorite-sku-icon").removeClass("hide");
    
    illiFavorite.find(".wishlist-loader").addClass("hide");
    illiFavorite.find(".favorite-icon").removeClass("hide");
    screenUnlock(); 
  }
  );
}


function dummyItem() {
  const dummyItem = [
    {
      "productsId": "6840129716391",
      "variantsId": "40604238839975",
      "image": null,
      "handle": "/products/test",
      "title": "Test M",
      "price": "200",
      "addCart": false
    },
    {
      "productsId": "6840129716391",
      "variantsId": "40604238807207",
      "image": "https://cdn.shopify.com/s/files/1/0504/5465/9262/products/Test_360x.jpg?v=1603242331",
      "handle": "/products/test",
      "title": "Test S",
      "price": "100",
      "addCart": true
    },
    {
      "productsId": "6840129716391",
      "variantsId": "40604238807208",
      "image": "https://cdn.shopify.com/s/files/1/0577/9800/0792/products/food_pizza_550x550.png?v=1625806432",
      "handle": "/products/test",
      "title": "Test L",
      "price": "3000～",
      "addCart": true
    },
    {
      "productsId": "6840129716391",
      "variantsId": "40604238807207",
      "image": "https://cdn.shopify.com/s/files/1/0504/5465/9262/products/Test_360x.jpg?v=1603242331",
      "handle": "/products/test",
      "title": "Test S",
      "price": "100",
      "addCart": true
    },
    {
      "productsId": "6840129716391",
      "variantsId": "40604238807208",
      "image": "https://cdn.shopify.com/s/files/1/0504/5465/9262/products/Test_360x.jpg?v=1603242331",
      "handle": "/products/test",
      "title": "Test L",
      "price": "3000～",
      "addCart": true
    },
    {
      "productsId": "6840129716391",
      "variantsId": "40604238807207",
      "image": "https://cdn.shopify.com/s/files/1/0577/9800/0792/products/food_pizza_cut_meat_550x550.png?v=1625797629",
      "handle": "/products/test",
      "title": "Test S",
      "price": "100",
      "addCart": true
    },
    {
      "productsId": "6840129716391",
      "variantsId": "40604238807208",
      "image": "https://cdn.shopify.com/s/files/1/0504/5465/9262/products/Test_360x.jpg?v=1603242331",
      "handle": "/products/test",
      "title": "Test L",
      "price": "3000～",
      "addCart": true
    }
  ];
  return dummyItem;
}

function getParam(name, url) {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}


function deleteItemLoading(targetElement) {
  
  let setClass = "delete-item--loading";
  targetElement.classList.add('delete-item--loading');

  
  let spinnerDivElement = document.createElement('div');
  spinnerDivElement.id = "delete-item-loading-overlay__spinner";
  spinnerDivElement.className = "delete-item-loading-overlay__spinner";

  
  let spinnerSvgElement = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  spinnerSvgElement.setAttributeNS(null, "class", "delete-item-spinner");
  spinnerSvgElement.setAttributeNS(null, "viewBox", "0 0 66 66");

  
  let spinnerCircleElement = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
  spinnerCircleElement.setAttribute("class", "delete-item-path");
  spinnerCircleElement.setAttribute('cx', 33);
  spinnerCircleElement.setAttribute('cy', 33);
  spinnerCircleElement.setAttribute('r', 30);
  spinnerCircleElement.setAttribute('fill', 'none');
  spinnerCircleElement.setAttribute('stroke-width', 6);

  
  spinnerSvgElement.appendChild(spinnerCircleElement);
  spinnerDivElement.appendChild(spinnerSvgElement);
  targetElement.appendChild(spinnerDivElement);
}


function deleteItemUnloading() {
  
  const element = document.getElementById('delete-item-loading-overlay__spinner');
  
  if (element == null) {
    return
  }
  element.remove();

  
  let elements = document.getElementsByClassName("delete-item--loading");
  Array.prototype.forEach.call(elements, function (element) {
    element.classList.remove("delete-item--loading");
  });
}
